module.exports = __webpack_public_path__ + "static/img/icon-02.1c928fdb.png";